import { useState } from 'react';
import { Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { ExportCashFlowsDialog } from './ExportCashFlowsDialog';

export function ExportCashFlowsButton() {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <Button
        variant='contained'
        color='secondary'
        startIcon={<DownloadIcon />}
        onClick={() => setDialogOpen(true)}
        sx={{ justifySelf: 'end' }}
      >
        Export Cash Flows
      </Button>

      <ExportCashFlowsDialog open={dialogOpen} onClose={() => setDialogOpen(false)} />
    </>
  );
}
